import { Box } from "@mui/material";
import { curatedAngleSelectorStyleProps } from "../theme/main";

type CuratedAngleSelectorProps = {
  angles: string[];
  activeAngleIndex: number;
  onChange: (angleIndex: number) => void;
};

export function CuratedAngleSelector({
  angles,
  activeAngleIndex,
  onChange,
}: CuratedAngleSelectorProps) {
  const { containerStyle, itemStyle, activeItemStyle, separatorStyle } =
    curatedAngleSelectorStyleProps;

  return (
    <Box
      role="tablist"
      aria-label="Curated view angles"
      sx={{
        display: "flex",
        alignItems: "center",
        ...containerStyle,
      }}
    >
      {angles.map((angle, index) => {
        const isActive = index === activeAngleIndex;

        return (
          <Box
            key={`${angle}-${index}`}
            sx={{
              display: "flex",
              alignItems: "center",
              ...containerStyle,
            }}
          >
            <Box
              component="button"
              type="button"
              role="tab"
              aria-selected={isActive}
              onClick={() => onChange(index)}
              sx={{
                appearance: "none",
                border: 0,
                background: "transparent",
                cursor: "pointer",
                fontFamily: "inherit",
                lineHeight: 1,
                margin: 0,
                padding: 0,
                ...itemStyle,
                ...(isActive ? activeItemStyle : {}),
              }}
            >
              {angle}
            </Box>
            {index < angles.length - 1 && (
              <Box component="span" aria-hidden="true" sx={separatorStyle}>
                .
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
}
